// src/hooks/useNotifications.js
import { useState, useEffect } from "react";
import {
  collection, query, orderBy, onSnapshot,
  addDoc, updateDoc, doc, serverTimestamp, where, getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";

export function useNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    const q = query(
      collection(db, "notifications"),
      where("uid", "==", user.uid),
      orderBy("createdAt", "desc")
    );
    const unsub = onSnapshot(q, (snap) => {
      const notifs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setNotifications(notifs);
      setUnreadCount(notifs.filter(n => !n.read).length);
    });
    return unsub;
  }, [user]);

  async function markAllRead() {
    const unread = notifications.filter(n => !n.read);
    await Promise.all(
      unread.map(n => updateDoc(doc(db, "notifications", n.id), { read: true }))
    );
  }

  return { notifications, unreadCount, markAllRead };
}

// ── Standalone function to send a notification ──
export async function sendNotification(uid, message, type = "info") {
  await addDoc(collection(db, "notifications"), {
    uid,
    message,
    type,
    read: false,
    createdAt: serverTimestamp()
  });
}

// ── Get all doctor UIDs to notify them ──
export async function notifyAllDoctors(message, type = "info") {
  const q = query(collection(db, "users"), where("role", "==", "doctor"));
  const snap = await getDocs(q);
  await Promise.all(
    snap.docs.map(d =>
      addDoc(collection(db, "notifications"), {
        uid: d.id,
        message,
        type,
        read: false,
        createdAt: serverTimestamp()
      })
    )
  );
}